// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5102":"ff85fbca5fdcd612","9484":"4dfa2e3f2030ae9f"}[chunkId] + ".css";
};